module.exports = __webpack_public_path__ + "img/13-s.65b489d7.png";